<div class="structural-unit-page page">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
  <h4>
    {{ 'pages.department.title' | translate }}
  </h4>
  @if (isLoading) {
    <app-spinner [isLoading]="isLoading" />
  } @else {
    <div class="structural-unit-wrapper">
      @for (unit of structuralUnits; track unit.id) {
        <app-structural-unit [structuralUnit]="unit" [isCrudLoading]="isCrudLoading" (structuralUnitEdit)="editStructuralUnit($event)" />
      }
    </div>
  }
</div>
